import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'underlineMatch'})

export class UnderlineMatchPipe implements PipeTransform {
  transform(productName: string, search: string, splitString?: string, isBackground?: boolean): string {
    if (!productName || !search) {
      return productName;
    }

    const replacePattern = isBackground ? '<span class="mark px-0"><strong>$&</strong></span>' : '<strong>$&</strong>';

    if (splitString && search) {
      // Replace spaces to vertical bar to highlight all words in the product name "bmc oracle 64" -> "bmc|oracle|64"
      productName = productName.toString().replace(new RegExp(search.replace(/ /g, '|'), 'gi'), replacePattern);
      return productName;
    }

    return productName.replace(new RegExp(search, 'i'), replacePattern);
  }
}
